// Excel download (write-excel-file v4, browser build). Rows are objects with Thai column names as keys.
export async function downloadXlsx(rows: Record<string, string | number | boolean>[], fileName: string): Promise<void> {
  const { default: writeXlsxFile } = await import('write-excel-file/browser');
  const headers = rows.length > 0 ? Object.keys(rows[0]) : ['ไม่มีข้อมูล'];
  const data = [
    headers.map((h) => ({ value: h, fontWeight: 'bold' as const })),
    ...rows.map((r) => headers.map((h) => {
      const v = r[h];
      return { value: typeof v === 'boolean' ? (v ? 'ใช่' : 'ไม่') : v };
    })),
  ];
  await writeXlsxFile(data).toFile(fileName);
}
